import React, { useEffect, useState } from "react";
import { Input, Button, Drawer, Slider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../Components/Loader/Loader";
import { build_Action_Supporting_Document_Quick_RunHandler } from "../../../../Redux/Actions/user/BuildQuickActionQuickSearch";

const QuickSearchRun = ({
  getSupportingDocId,

  setViewResult,
  ViewResult,

  handleShowQuickSearch,
  showQuickSearch,
}) => {
  const SideClose = "/assets/ModalClose.svg";
  const dispatch = useDispatch();
  const [sliderValue, setSliderValue] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const handleSliderChange = (value) => {
    setSliderValue(value);
  };

  const QuickSearchData = useSelector(
    (state) =>
      state?.build_Action_Supporting_Document_Quick_Run_Data
        ?.build_action_supporting_document_quick_run_data
  );

  const QuickSearchDataLoader = useSelector(
    (state) => state?.build_Action_Supporting_Document_Quick_Run_Data?.loader
  );

  useEffect(() => {
    if (QuickSearchData?.data?.search_result) setViewResult(QuickSearchData);
    // eslint-disable-next-line
  }, [QuickSearchData?.data?.search_result]);

  useEffect(() => {
    setViewResult("");
  }, []);

  const handleQuickSearchApi = () => {
    if (searchInput) {
      let request = {
        search_type: "context",
        search_query: searchInput,
        relevance_score: sliderValue,
      };

      dispatch(
        build_Action_Supporting_Document_Quick_RunHandler(
          request,
          getSupportingDocId
        )
      );
    }
  };
  return (
    <>
      <Drawer
        placement="right"
        closable={false}
        onClose={handleShowQuickSearch}
        open={showQuickSearch}
        key="right"
        width={"40%"}
      >
        {QuickSearchDataLoader && (
          <div className="temportal-loader-overlay">
            <div className="temporal-loader"></div>
          </div>
        )}
        <img
          className="delete-refer-data-sideClose"
          src={SideClose}
          alt=""
          onClick={handleShowQuickSearch}
        />

        <div className="delete-refer-data-modal-div">
          <h3>Quick Search</h3>
        </div>
        <div className="delete-refer-data-input">
          <div className="delete-refer-data-1">
            <label>Context Search</label>
            <Input
              placeholder="context Search"
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
            />
          </div>
          <div className="delete-refer-data-2">
            <div className="slider-container">
              <span> Not as relevant</span>
              <Slider
                defaultValue={0}
                disabled={false}
                className="slider-class"
                onChange={handleSliderChange}
              />
              <span>Relevant</span>
            </div>
            {ViewResult && ViewResult?.data && (
              <div>
                <div className="quick-search-data-count">
                  <h4 id="count1">Result</h4>
                  <h4 id="count2">
                    word Count:
                    {ViewResult?.data?.search_result?.length || 0}
                  </h4>
                </div>
                <div className="delete-refer-data-main-content">
                  <p>{ViewResult?.data?.search_result || null}</p>
                </div>
              </div>
            )}

            <div className="delete-refer-data-supporting-div">
              {ViewResult && ViewResult?.data ? (
                <Button
                  className="delete-refer-data-supporting-button"
                  onClick={handleShowQuickSearch}
                >
                  Use
                </Button>
              ) : (
                <Button
                  className="delete-refer-data-supporting-button"
                  onClick={handleQuickSearchApi}
                >
                  Search
                </Button>
              )}
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};
export default QuickSearchRun;
